<template>
    <div class="container mt-4">
        <h4>SCP Command Generator</h4>
        <div class="mb-3">
            <label class="form-label">Relative Path (e.g., ptr/app/Repositories/StudentRepository.php)</label>
            <input v-model="relativePath" class="form-control" placeholder="Enter path..." />
        </div>

        <div class="mb-3">
            <label class="form-label">Username</label>
            <input v-model="username" class="form-control" placeholder="e.g., user123" />
        </div>

        <div class="mb-3">
            <label class="form-label">Host (IP or domain)</label>
            <input v-model="host" class="form-control" placeholder="e.g., 192.168.1.10" />
        </div>

        <div class="mb-3">
            <label class="form-label">Remote Base Path</label>
            <input v-model="remoteBase" class="form-control" placeholder="e.g., shell/services" />
        </div>
        <div class="mb-3 d-flex gap-2">
            <button class="btn btn-sm btn-success" @click="addCommand" :disabled="!relativePath || !username || !host">
                ➕ Generate
            </button>
            <button class="btn btn-sm btn-secondary" @click="clearAll">
                ❌ Clear
            </button>
        </div>

        <div v-for="(cmd, index) in generatedCommands" :key="index"
            class="alert alert-secondary d-flex justify-content-between align-items-center">
            <code style="word-break: break-all;">{{ cmd }}</code>

        </div>
        <button class="btn btn-sm btn-outline-primary ms-2" @click="copyAllToClipboard(cmd)">
            📋 Copy
        </button>
    </div>
</template>

<script>
export default {
    data() {
        return {
            relativePath: '',
            username: 'n2a64f5',
            host: '144.208.64.167',
            remoteBase: 'shell/services',
            generatedCommands: []
        };
    },
    methods: {
        copyAllToClipboard() {
            const allText = this.generatedCommands.join('\n');
            navigator.clipboard.writeText(allText)
                .then(() => alert("All commands copied to clipboard!"))
                .catch(err => alert('Failed to copy: ' + err));
        },
        addCommand() {
            const cleanPath = this.relativePath.replace(/^ptr\//, '');
            const cmd = `scp -r ${cleanPath} ${this.username}@${this.host}:${this.remoteBase}/ptr/${cleanPath}`;
            this.generatedCommands.push(cmd);
            this.relativePath = '';
        },
        clearAll() {


            this.generatedCommands = [];
        }
    },
    computed: {
        generatedCommand() {
            if (!this.relativePath) return '';

            const cleanPath = this.relativePath.replace(/^ptr\//, '');
            return `scp -r ${cleanPath} ${this.username}@${this.host}:${this.remoteBase}/ptr/${cleanPath}`;
        }
    }
};
</script>